import { useRef, useState, useEffect } from 'react'
import { ReactSVG } from 'react-svg'

import DashboardIcon from 'components/ui/account/nabvar-v2-left/icons/Dashboard.svg'
import LoansIcon from 'components/ui/account/nabvar-v2-left/icons/Loans.svg'
import SavingsIcon from 'components/ui/account/nabvar-v2-left/icons/Savings.svg'
import ExchangeIcon from 'components/ui/account/nabvar-v2-left/icons/Exchange.svg'
import WalletIcon from 'components/ui/account/nabvar-v2-left/icons/Wallet.svg'

import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import ActiveTabBackground from './images/active-tab-background.png'

import styles from './styles.module.scss'

export const TabNames = {
  ALL: 'All',
  LOANS: 'Loans',
  SAVINGS: 'Savings',
  EXCHANGE: 'Exchange',
  WALLETS: 'Wallets',
}

export function TransactionHistoryTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation()

  const [activePosition, setActivePosition] = useState({ left: -4 })

  const hoverEl = useRef()

  const activateTab = (event, tabName) => {
    onTabChange(tabName)
    const link = event.target.closest('div')
    const linkRect = link.getBoundingClientRect()
    const containerRect = link.parentElement.getBoundingClientRect()
    setActivePosition({ left: linkRect.left - containerRect.left - 4 })
  }

  useEffect(() => {
    const activeLink = document.querySelector(`.${styles.tab}.${styles.activeTab}`)
    if (activeLink && typeof activeTab !== 'undefined') {
      const linkRect = activeLink.getBoundingClientRect()
      const containerRect = activeLink.parentElement.getBoundingClientRect()
      setActivePosition({ left: linkRect.left - containerRect.left - 4 })
    }
  }, [activeTab])

  const tabs = [
    { name: TabNames.ALL, icon: DashboardIcon, label: 'all' },
    { name: TabNames.LOANS, icon: LoansIcon, label: 'loans' },
    { name: TabNames.SAVINGS, icon: SavingsIcon, label: 'savings' },
    { name: TabNames.EXCHANGE, icon: ExchangeIcon, label: 'exchange_btn' },
    { name: TabNames.WALLETS, icon: WalletIcon, label: 'wallets' },
  ]

  return (
    <>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab.name}
            className={cn(styles.tab, {
              [styles.activeTab]: typeof activeTab !== 'undefined' && activeTab === tab.name,
            })}
            onClick={(e) => activateTab(e, tab.name)}
          >
            <ReactSVG src={tab.icon} className={styles.icon} />
            <span className={styles.tabText}>{t(tab.label)}</span>
          </div>
        ))}
        <img
          ref={hoverEl}
          src={ActiveTabBackground}
          className={styles.activeBackground}
          style={{ transform: `translateX(${activePosition.left}px)` }}
        />
      </div>
    </>
  )
}
